"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MobxView = _interopRequireDefault(require("./MobxView"));

var _Propulator = _interopRequireDefault(require("./Propulator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(view, store, propNames) {
  return (0, _MobxView.default)((0, _Propulator.default)(view, {
    "viewStore": propNames
  }), {
    "viewStore": store
  });
};

exports.default = _default;